/**
 * Opens the paper "About this map" sheet from anywhere (the attribution pill,
 * the layers card footer, the panel footer's "About this map" button — B7).
 *
 *   import { openAbout } from "@/features/hud/Hud";
 *   <Button variant="quiet" onClick={(e) => openAbout(e.currentTarget)}>About this map</Button>
 *
 * The sheet itself is rendered by <Hud/>; focus returns to `opener` when it closes.
 * No React state here: a tiny listener set, safe under StrictMode double mounts.
 */
type Listener = (opener: HTMLElement | null) => void;

const openers = new Set<Listener>();
const closers = new Set<() => void>();

export function openAbout(opener?: HTMLElement | null): void {
  const el = opener ?? (typeof document !== "undefined" && document.activeElement instanceof HTMLElement ? document.activeElement : null);
  openers.forEach((l) => l(el));
}

export function closeAbout(): void {
  closers.forEach((l) => l());
}

/** Used by the sheet. Returns the unsubscribe function. */
export function onAboutRequest(open: Listener, close: () => void): () => void {
  openers.add(open);
  closers.add(close);
  return () => {
    openers.delete(open);
    closers.delete(close);
  };
}
